export { FullNameField, NameInput } from './FullNameField';
export { checkMatchNameBday, checkMatchNameEmail, checkMatchNamePhone, checkName } from './FullNameField.validation';
